import { getApiURL } from '../api';

const fetchCountryList = async () => {
  const response = await fetch(`${getApiURL()}v0/geodata/countries/`);
  return response.json();
};

export default fetchCountryList;
